export const sidebarProps = {
  'teacher': {
    keys: [
      'dashboard',
      'announcements',
      'lessonLibrary',
      'lessons',
      'notes',
      'classes',
      'featuredLab',
      'groundTrials',
      'deviceManager',
      'virtualExolab'
    ]
  },
  'district-admin': {
    keys: [
      'dashboard',
      'announcements',
      'lessonLibrary',
      'studentNotes'
    ]
  },
  'student': {
    keys: [
      'dashboard',
      'announcements',
      'myNotes',
      'essays',
      'featuredLab',
      'groundTrials',
      'deviceManager',
      'virtualExolab'
    ]
  },
  'superadmin': {
    keys: [
      'dashboard',
      'announcements',
      'lessonLibrary',
      'createLesson',
      'manageUsers',
      'featuredLab',
      'groundTrials',
      'virtualExolab'
    ]
  },
  'author': {
    keys: [
      'dashboard',
      'announcements',
      'lessonLibrary',
      'lessons'
    ]
  },
  'editor': {
    keys: []
  },
  'homeschool': {
    keys: []
  }
}
